import Vue from 'vue'

export default {
  getAll () {
    return Vue.http.get('/logistics/locations')
  },

  get (id) {
    return Vue.http.get(`/logistics/locations/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/logistics/location.js